<div *ngIf="template">
  <div class="card p-0 pt-4 mb-0">
    <div class="flex flex-column mx-4 mb-3">
      <div class="flex flex-column sm:flex-row justify-content-start sm:justify-content-between mb-3">
        <p class="inline-block text-4xl flex-order-1 sm:flex-order-0">
          {{'model.template' | transloco}} {{template.name}}
        </p>
        <div class="flex-order-0 sm:flex-order-1">
          <button
            *ngIf="('ROLE_SUPER_ADMIN' | userHasRole) || ('ROLE_ADMIN' | userHasRole: false)"
            [label]="'common.edit' | transloco"
            pButton
            pRipple
            class="mr-2 p-button-primary mt-1 mb-3 sm:mb-0 w-full sm:w-auto"
            routerLink="../edit"
            icon="pi pi-pencil"
          ></button>
        </div>
      </div>
      <div>
        <p *ngIf="template.description"><b>{{'attribute.description' | transloco}}: </b>{{template.description}}</p>
        <p *ngIf="!template.description" class="font-italic">{{'empty.description' | transloco}}</p>
      </div>
    </div>
    <div>
      <p-tabMenu
        #tab
        [model]="items"
        [activeItem]="activeItem"
        (click)="activateMenu(tab)"
        class="hidden xl:inline"
      ></p-tabMenu>
      <p-tabMenu
        #tabIcon
        [model]="items"
        [activeItem]="activeItem"
        (click)="activateMenu(tabIcon)"
        class="xl:hidden"
      >
        <ng-template pTemplate="item" let-item let-i="index">
          <i [className]="item.icon"></i>
        </ng-template>
      </p-tabMenu>
    </div>
  </div>
  <div class="with-margin">
    <app-template-overview [template]="template" *ngIf="activeItem.id == 'overview'"></app-template-overview>
    <app-template-sensors [template]="template" *ngIf="activeItem.id == 'sensors'"></app-template-sensors>
    <app-template-properties [template]="template" *ngIf="activeItem.id == 'properties'"></app-template-properties>
    <app-template-integration-modules [template]="template" *ngIf="activeItem.id == 'integrationModules'"></app-template-integration-modules>
  </div>
</div>
